import React from 'react'
import { useActiveOrgIntegration } from 'src/queries/organizations/integrations.queries'
import { useQueryOrganizationSaasTier } from 'src/queries/organizations/saas.queries'
import { useQueryOwnUser } from 'src/queries/users.queries'

import {
  PanelGatedState,
  ReportingPanelQueryParams,
} from './reportingPanelUtils'
import SpendStackedBarPanel from './SpendStackedBarPanel'

const SpendByAccountingCategoryPanel: React.FC<ReportingPanelQueryParams> = (
  props,
) => {
  const { data: currentUser } = useQueryOwnUser({})
  const { data: saasTier, isFetched: isSaasTierFetched } =
    useQueryOrganizationSaasTier({
      orgId: props.organizationId,
      enabled: props.enabled,
    })
  const { data: activeIntegration, isFetched: isIntegrationFetched } =
    useActiveOrgIntegration({
      orgId: props.organizationId,
      enabled: props.enabled,
    })

  const gatedState: PanelGatedState | undefined =
    isSaasTierFetched && saasTier?.tier === 'STARTER'
      ? { type: 'not_entitled' }
      : isIntegrationFetched && activeIntegration === undefined
        ? { type: 'not_connected' }
        : undefined

  return (
    <SpendStackedBarPanel
      {...props}
      chartId="spend_by_accounting_category"
      title="Spend by account"
      description="Spend grouped by account."
      summaryLabel="Top account"
      gatedState={gatedState}
      isAdmin={currentUser?.hasOrgAdminPermissions}
      enabled={props.enabled && !gatedState}
    />
  )
}

export default SpendByAccountingCategoryPanel
